import React, { useEffect, useState } from 'react';
import './DemoTour.css';

const DemoTour = ({ runTour, setRunTour, handleTabChange }) => {
    const [stepIndex, setStepIndex] = useState(0);

    const steps = [
        {
            selector: '.banner-greeting',
            content: "Hi, I'm your garden companion. Welcome to Homebase - your seasonal dashboard.",
        },
        {
            selector: '.banner-column-seasonal',
            content: "Here I will present you with seasonal tips, relevant to the time of year.",
        },
        {
            selector: '.banner-column-announcement',
            content: "Watch for announcements which could include contests in your area.",
        },
        {
            selector: '.post-composer',
            content: "Want to share your garden? Add captions, upload images, and start threads with fellow growers.",
        },
        {
            selector: '.social-section',
            content: "Scroll through community posts. React, comment, and learn from others in your growing zone.",
        },
        {
            selector: '.tasks-section',
            content: "This is your task center. I'll nudge you with reminders to keep your veggies thriving. When you answer a task, I'll store it in your Garden Journal for future reference.",
        },
        {
            selector: '.tab-garden-journal',
            content: "Let's open your Garden Journal and take a look.",
            action: () => handleTabChange('Garden Journal'),
        }
    ];

    useEffect(() => {
        if (!runTour || stepIndex >= steps.length) return;

        const { selector, content, action } = steps[stepIndex];
        const el = document.querySelector(selector);

        if (!el || el.offsetParent === null) {
            console.warn(`Step ${stepIndex} target not visible � retrying...`);
            setTimeout(() => setStepIndex(stepIndex), 300);
            return;
        }

        // Scroll into view and focus if possible
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (typeof el.focus === 'function') {
            setTimeout(() => el.focus(), 100); // slight delay to avoid layout jump
        }

        // Highlight the element
        el.classList.add('demo-highlight');

        // Create tooltip
        const tooltip = document.createElement('div');
        tooltip.className = 'demo-tooltip';
        tooltip.innerText = content;
        document.body.appendChild(tooltip);

        const rect = el.getBoundingClientRect();
        tooltip.style.top = `${rect.bottom + 8}px`;
        tooltip.style.left = `${rect.left}px`;

        // Trigger action if needed
        if (action) {
            action(); // trigger tab change

            // Wait until the new selector is visible
            const waitForTarget = () => {
                const nextEl = document.querySelector(selector);
                if (nextEl && nextEl.offsetParent !== null) {
                    nextEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    if (typeof nextEl.focus === 'function') {
                        setTimeout(() => nextEl.focus(), 100);
                    }
                    nextEl.classList.add('demo-highlight');

                    const tooltip = document.createElement('div');
                    tooltip.className = 'demo-tooltip';
                    tooltip.innerText = content;
                    document.body.appendChild(tooltip);

                    const rect = nextEl.getBoundingClientRect();
                    tooltip.style.top = `${rect.bottom + 8}px`;
                    tooltip.style.left = `${rect.left}px`;

                    const timer = setTimeout(() => {
                        nextEl.classList.remove('demo-highlight');
                        tooltip.remove();
                        setStepIndex((prev) => prev + 1);
                    }, 5000);

                    return () => {
                        clearTimeout(timer);
                        nextEl?.classList.remove('demo-highlight');
                        tooltip?.remove();
                    };
                } else {
                    setTimeout(waitForTarget, 300); // retry until visible
                }
            };

            waitForTarget();
            return; // prevent rest of effect from running
        }

        // Advance after 5 seconds
        const timer = setTimeout(() => {
            el.classList.remove('demo-highlight');
            tooltip.remove();
            setStepIndex((prev) => prev + 1);
        }, 5000);

        return () => {
            clearTimeout(timer);
            el?.classList.remove('demo-highlight');
            tooltip?.remove();
        };
    }, [runTour, stepIndex]);

    useEffect(() => {
        if (stepIndex >= steps.length) {
            setRunTour(false);
            setStepIndex(0);
        }
    }, [stepIndex]);

    return null; // no visible component
};

export default DemoTour;